var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("EmployeeMultiselect", {
    attrs: {
      value: _vm.chosenContractors,
      options: _vm.contractorsOptionsWithBookmarks,
      getcontainerStyle: _vm.getParentcontainerStyle,
      multiple: _vm.multiple,
      invalid: _vm.invalid,
      max: _vm.max,
      placeholder: _vm.placeholderText,
      loading: _vm.isLoading,
      disabled: _vm.disabled,
      noOptionsText: _vm.noOptionsText,
      "bookmarked-users": _vm.bookmarkedUsers,
      withoutLoading: "",
    },
    on: {
      search: (v) => (_vm.contractorSearchString = v),
      input: _vm.handleInput,
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }